import { render, staticRenderFns } from "./asinSpecification.vue?vue&type=template&id=2e3fafc0&scoped=true"
import script from "./asinSpecification.vue?vue&type=script&lang=js"
export * from "./asinSpecification.vue?vue&type=script&lang=js"
import style0 from "./asinSpecification.vue?vue&type=style&index=0&id=2e3fafc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3fafc0",
  null
  
)

export default component.exports